export default "__VITE_ASSET__BfHNjB_r__"